var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_outer"},[_c('header',[_c('el-page-header',{staticClass:"flex align_center",attrs:{"content":_vm.title},on:{"back":function($event){_vm.$router.go(-1)}}})],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214f58ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/outer/index.vue
// module id = null
// module chunks = 